import { Component, OnInit } from '@angular/core';
import { RouteHandlerService } from '../common/services/routeHandler.service';
import { FormValidator } from '../common/services/formValidator.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Formatter } from '../common/services/formatter';
import { CommonConstants } from '../common/utilities/commonConstants';
import { OTPVerificationService } from './emiOtpVerification.service';
import { SessionHandlerService } from './../common/services/sessionHandler.service';
import { PaymentStatusService } from './../paymentReview/paymentStatus.service';

@Component({
    templateUrl: './emiOtpVerification.template.html',
    styleUrls: ['./emiOtpVerification.style.scss'],
    providers: [OTPVerificationService, PaymentStatusService]
})
export class OTPVerificationComponent implements OnInit {
    systemPaymentId: any;
    public OTPForm: FormGroup;
    showLoader: boolean;
    currentTaskKey: string;
    amount: number;
    public resendOtp: boolean;
    public tenure: number;
    public mobileNumber;
    public MainLoadingText = 'Stay with us. We\'re almost done...';
    constructor(private _routerService: RouteHandlerService,
        public FormValidators: FormValidator,
        private _formBuilder: FormBuilder,
        public formatter: Formatter,
        private _otpVerificationService: OTPVerificationService,
        private _sessionStorage: SessionHandlerService,
        private paymentStatusService: PaymentStatusService    ) {
        this.currentTaskKey = CommonConstants.EMIOTPNEXTTASKKEY;
    }
    // On component Init
    public ngOnInit() {
        this.buildFormElement();
        const fetchPaymentData = {
            applicationId: JSON.parse(this._sessionStorage.GetSession(CommonConstants.CookieKeys.applicationId)),
            quoteId: this._sessionStorage.GetSession(CommonConstants.CookieKeys.selectedQuoteId)
        };
        this.fetchPaymentStatus(fetchPaymentData);

    }
    private buildFormElement() {
        this.OTPForm = this._formBuilder.group({
            OTP: ['', Validators.compose([Validators.required])]
        });
    }
    public Next() {
        const payload = {
            otp: this.OTPForm.controls['OTP'].value
        };
        this.sendOPTPostCall(payload, 'Next');
    }
    public Back() {
        this.sendOPTPostCall(null, 'Back');
    }
    public resend() {
        this.sendOPTPostCall(null, 'Resend');
    }
    private sendOPTPostCall(data, action) {
        this.showLoader = true;
        const requestData = {
            action: action,
            payload: data
        };
        this._otpVerificationService.PostCallEMIOTP(requestData).subscribe((mtResponse) => {
            if (!mtResponse.errorBean) {
                this.showLoader = false;
                if (mtResponse.nextTaskKey === 'insHurrayPage' || mtResponse.nextTaskKey === 'insPolicyPage') {
                    this._sessionStorage.SetSession(CommonConstants.CookieKeys.NextTaskKeyOmHR, mtResponse.nextTaskKey);
                }
                if (mtResponse.nextTaskKey === 'retryPaymentPage' || mtResponse.nextTaskKey === 'insHurrayPage') {
                    this._routerService.RouteToNextTask(mtResponse.nextTaskKey, null, null, true);
                }
                if (mtResponse.nextTaskKey !== CommonConstants.EMIOTPNEXTTASKKEY) {
                    this._routerService.RouteToNextTask(mtResponse.nextTaskKey);

                } else if (action === 'Resend' && mtResponse.nextTaskKey === CommonConstants.EMIOTPNEXTTASKKEY) {
                    this.resendOtp = true;
                }
            }
            this.showLoader = false;
        },
            () => {
                this.showLoader = false;
            });
    }
    private fetchPaymentStatus(requestData: any) {
        this.paymentStatusService
            .FetchPaymentStatus(requestData)
            .subscribe((resp: Model.MTResponse<any>) => {
                const mtPaymentStatusResponse: Model.MTResponse<any> = resp;
                if (mtPaymentStatusResponse.payload !== null) {
                    if (!resp.payload) { return; }
                    this.showLoader = false;
                    const paymentStatusResp = resp.payload.paymentStatusResponse;
                    this.amount = paymentStatusResp.paymentAmount;
                    this.mobileNumber = resp.payload.mobileNo;
                    this.systemPaymentId = paymentStatusResp.systemPaymentId;
                }
            });
    }
}
